// Single source of truth for workplace-request priority presentation (labels +
// colors). Shared by the detail-modal Priority select (dots) and the queue table
// row accent line, so the same color always maps to the same priority.

export type WorkplaceRequestPriority = 1 | 2 | 3;

export interface PriorityMeta {
  value: WorkplaceRequestPriority;
  label: string;
  /** Tailwind background class for dots/indicators. */
  dotClass: string;
  /** Raw hex color for contexts that need a color value (e.g. the table row accent line). */
  color: string;
}

export const PRIORITY_META: Record<WorkplaceRequestPriority, PriorityMeta> = {
  1: { value: 1, label: "Low", dotClass: "bg-neutral-400", color: "#a3a3a3" },
  2: { value: 2, label: "Medium", dotClass: "bg-amber-500", color: "#f59e0b" },
  3: { value: 3, label: "High", dotClass: "bg-red-500", color: "#ef4444" }
};

export const PRIORITY_OPTIONS = Object.values(PRIORITY_META);

export const getPriorityMeta = (
  priority?: number | null
): PriorityMeta | null =>
  priority === 1 || priority === 2 || priority === 3
    ? PRIORITY_META[priority]
    : null;

/**
 * Accent color for a ticket's row line, mapped from priority. Low priority has
 * no line (returns null) — only Medium/High get an accent.
 */
export const getPriorityAccentColor = (
  priority?: number | null
): string | null => {
  const meta = getPriorityMeta(priority);
  if (!meta || meta.value === 1) return null;
  return meta.color;
};
